import Loadable from 'components/Loadable';

const supplyChain = {
  path: '/supply-chain-assurance',
  component: Loadable({
    loader: () => import('../views/promotions/supply-chain'),
  }),
  routes: [
    {
      exact: true,
      path: '/supply-chain-assurance',
      component: Loadable({
        loader: () => import('../views/promotions/supply-chain/landing'),
      }),
    },
  ],
};

export default supplyChain;
